<script setup>
import { computed } from 'vue';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import wootConstants from 'dashboard/constants/globals';

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
  activeTab: {
    type: String,
    default: wootConstants.ASSIGNEE_TYPE.ME,
  },
});

const emit = defineEmits(['chatTabChange']);

const activeTabIndex = computed(() => {
  return props.items.findIndex(item => item.key === props.activeTab);
});

const onTabChange = selectedTabIndex => {
  if (selectedTabIndex >= 0 && selectedTabIndex < props.items.length) {
    const selectedItem = props.items[selectedTabIndex];
    if (selectedItem.key !== props.activeTab) {
      emit('chatTabChange', selectedItem.key);
    }
  }
};

const keyboardEvents = {
  'Alt+KeyN': {
    action: () => {
      if (props.activeTab === wootConstants.ASSIGNEE_TYPE.ALL) {
        onTabChange(0);
      } else {
        const nextIndex = (activeTabIndex.value + 1) % props.items.length;
        onTabChange(nextIndex);
      }
    },
  },
};

useKeyboardEvents(keyboardEvents);
</script>

<template>
  <!-- Trilho segmentado: mesma linguagem da barra lateral da conversa.
       A Fila acende em ambar quando ha gente esperando. -->
  <div
    class="mx-2 my-1.5 flex items-center gap-1 rounded-[11px] bg-[#E2DDD5] p-[3px] dark:bg-[#100E0D]"
  >
    <button
      v-for="(item, index) in items"
      :key="item.key"
      class="flex flex-1 items-center justify-center gap-1.5 rounded-lg px-2 py-1.5 text-[12px] font-semibold outline-none transition-all duration-150"
      :class="
        index === activeTabIndex
          ? 'bg-white text-n-slate-12 shadow-sm dark:bg-[#332E2A]'
          : 'text-n-slate-10 hover:text-n-slate-12'
      "
      @click="onTabChange(index)"
    >
      <span
        v-if="item.icon"
        class="size-3 flex-shrink-0"
        :class="[item.icon]"
      />
      <span>{{ item.name }}</span>
      <span
        v-if="item.count !== undefined"
        class="rounded-full px-1.5 text-center text-[9.5px] font-bold leading-4 tabular-nums text-white"
        :class="
          item.key === 'unassigned' && item.count > 0
            ? 'bg-n-amber-9'
            : index === activeTabIndex
              ? 'bg-n-brand'
              : 'bg-n-slate-8'
        "
      >
        {{ Number(item.count || 0).toLocaleString('pt-BR') }}
      </span>
    </button>
  </div>
</template>
